export default __webpack_public_path__ + "static/media/pin.31e630e6.PNG";